import HomeGreetings from "../../components/HomeGreetings/HomeGreetings";

const HomePage = () => {
  return (
    <div>
      <HomeGreetings />
    </div>
  );
};
export default HomePage;
